import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { buttonLargeStyles, buttonMediumStyles, buttonSmallStyles } from '@nib-components/theme';
import { breakpoint, Column, Columns, map, py, px } from '@nib/layout';
import Loader from '@nib/loader';
export const validSizes = ['small', 'medium', 'large'];
export const validIconPlacement = ['left', 'right', 'start', 'end'];
export const fullWidthStyling = css`
  ${props => {
  var _props_fullWidth;
  return map((_props_fullWidth = props.fullWidth) !== null && _props_fullWidth !== void 0 ? _props_fullWidth : false, val => {
    if (val) {
      return `
          width: 100%;
        `;
    } else {
      return `width: auto;`;
    }
  });
}}
`;
export const sizeStyling = css`
  /* Reduce padding below 240px screen */
  ${breakpoint('xs', 'mini')`
    ${py(2)};
    ${px(3)};
  `}

  ${props => {
  var _props_size;
  const intepretedSize = props.small ? 'small' : props.large ? 'large' : (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : 'medium';
  return map(intepretedSize, val => {
    if (val === 'small') {
      return css`
          ${buttonSmallStyles(props)};
        `;
    } else if (val === 'large') {
      return css`
          ${buttonLargeStyles(props)};
        `;
    } else {
      return css`
          ${buttonMediumStyles(props)};
        `;
    }
  });
}}
`;
export const StyledSpan = styled.span`
  word-break: break-word;
`;
const StyledLineHeight = styled.div`
  line-height: 0;
`;
const ShrinkColumn = styled(Column)`
  flex-shrink: 1;
`;
const BaseButton = /*#__PURE__*/forwardRef((props, ref) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */const {
    component = 'button',
    icon: Icon,
    iconPlacement = 'end',
    size = 'medium',
    small = false,
    large = false,
    fullWidth = false,
    isCompact,
    isLoading = false,
    children,
    ...otherProps
  } = props;
  const Component = 'href' in props ? 'a' : component;
  return /*#__PURE__*/_jsx(Component, {
    ref: ref,
    ...otherProps,
    children: /*#__PURE__*/_jsxs(Columns, {
      space: 2,
      verticalAlign: "center",
      align: "center",
      wrap: true,
      children: [Icon && !isLoading && (iconPlacement === 'left' || iconPlacement === 'start') && /*#__PURE__*/_jsx(Column, {
        width: "content",
        children: /*#__PURE__*/_jsx(StyledLineHeight, {
          children: /*#__PURE__*/_jsx(Icon, {
            size: "xs",
            fill: "currentColor"
          })
        })
      }), isLoading && (iconPlacement === 'left' || iconPlacement === 'start') && /*#__PURE__*/_jsx(Column, {
        width: "content",
        children: /*#__PURE__*/_jsx(StyledLineHeight, {
          children: /*#__PURE__*/_jsx(Loader, {
            size: "xs",
            fill: "currentColor"
          })
        })
      }), /*#__PURE__*/_jsx(ShrinkColumn, {
        width: "content",
        children: /*#__PURE__*/_jsx(StyledSpan, {
          children: children
        })
      }), Icon && !isLoading && (iconPlacement === 'right' || iconPlacement === 'end') && /*#__PURE__*/_jsx(Column, {
        width: "content",
        children: /*#__PURE__*/_jsx(StyledLineHeight, {
          children: /*#__PURE__*/_jsx(Icon, {
            size: "xs",
            fill: "currentColor"
          })
        })
      }), isLoading && (iconPlacement === 'right' || iconPlacement === 'end') && /*#__PURE__*/_jsx(Column, {
        width: "content",
        children: /*#__PURE__*/_jsx(StyledLineHeight, {
          children: /*#__PURE__*/_jsx(Loader, {
            size: "xs",
            fill: "currentColor"
          })
        })
      })]
    })
  });
});
export default BaseButton;